import React, { Component } from "react"
import "./WelcomePage.css"
import { getTranslation } from "../../assets/creator/translations"
import LanguageSelector from "../../components/LanguageSelector/LanguageSelector"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInfo } from "@fortawesome/free-solid-svg-icons"
import { handleAcceptButton } from "../../utils/welcomePageUtils"
import SalesModel from "../../components/SalesModel/SalesModel"

class WelcomePage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedModel: "retail"
		}
	}

	render() {
		return (
			<div className="welcome-page">
				<div className="welcome-page__main-content">
					<div className="welcome-page__header">
						<div className="welcome-page__header-logo">
        				    <img src="./img/comarch_logo_mobile_browsers.svg" className="welcome-page__logo" alt="logo" />
        				</div>
					</div>
					<div className="welcome-page__content">
						<div className="welcome-page__content-left">
							<img src="./img/modals/firstVisit_big.png" className="welcome-page__img" alt="welcome" />
						</div>
						<div className="welcome-page__content-right">
							<div className='welcome-page__title'>
								{getTranslation("Msg_WelcomeFirstTime")}
							</div>
							<div className='welcome-page_conatiner'>
								<div className='welcome-page__text'>
									{getTranslation("Msg_DesignYourShop")}
								</div>
								<div className="welcome-page__models">
									{this.state.selectedModel === "wholesale" ? (
										<div className="welcome-page__models-info">
											<FontAwesomeIcon icon={faInfo} className="welcome-page__models-info-icon" />
											<div className="welcome-page__models-info-text">
												{getTranslation("Msg_WholesaleInfo")}
											</div>
										</div>
									) : null}
									<div className="welcome-page__models-content">
										<SalesModel 
											modelTitle={getTranslation("Msg_RetailTitle")}
											modelText={getTranslation("Msg_RetailText")}
											isSelected={this.state.selectedModel === "retail" ? true : false}
											clickFunction={() => this.setState({ selectedModel: "retail" })}
										/>
										<SalesModel
											modelTitle={getTranslation("Msg_WholesaleTitle")}
											modelText={getTranslation("Msg_WholesaleText")}
											isSelected={this.state.selectedModel === "wholesale" ? true : false}
											clickFunction={() => this.setState({ selectedModel: "wholesale" })}
										/>
									</div>
								</div>
								<div className="welcome-page__btn-group">
									<button
										className='welcome-page__btn welcome-page__btn--active nextBtn'
										onClick={() => handleAcceptButton.call(this, false)}>
										{getTranslation("Btn_StartYourProject")}
									</button>
								</div>
							</div>
						</div>
					</div>
					<div className="welcome-page__footer">
						<span className="welcome-page__border-line"></span>
						<LanguageSelector
							langChangeHandler={this.props.onLangChange}
                			lang={this.props.currentLang}
						/>
					</div>
				</div>
			</div>
		)
	}
}

export default WelcomePage



// WEBPACK FOOTER //
// ./src/containers/WelcomePage/WelcomePage.js